import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { RequestApprovalDto } from '@bo-client/activation-management/grid-registration/model/RequestApprovalDto';
import { AnswerWithMoreInfoModel } from '@bo-client/activation-management/shared/models/AnswerWithMoreInfoModel';
import { takeUntil } from 'rxjs/operators';
import { ConfirmationRequestPageBase } from '@bo-client/shared/base-components/confirmation-request-page.base';

@Component({
  selector: 'app-gr-confirm-extension',
  templateUrl: './gr-confirm-extension.component.html',
  styleUrls: ['./gr-confirm-extension.component.scss']
})
export class GrConfirmExtensionComponent extends ConfirmationRequestPageBase<any> implements OnInit {
  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpService: HttpHapService,
    protected toastService: ToastrService,
    protected matDialog: MatDialog
  ) {
    super(route, router, httpService, toastService, matDialog);
  }

  compUnsubs$: Subject<void> = new Subject<void>();
  requestApprovalDto: RequestApprovalDto;
  uriGetData = 'not used';

  ngOnInit() {
    this.httpService
      .post({}, `/external/gridregistration/${this.id}/refreshValidity/${this.token}`)
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe((answer: AnswerWithMoreInfoModel) => {
        this.navigateTo(answer);
      });
  }

  hookGetDataFromForm() {}
}
